<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :title="title"
    show-close
    top="2vh"
    width="95%"
    :close-on-click-modal="false"
    :before-close="() => $refs.bookingForm.cancel()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <BookingForm
      ref="bookingForm"
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="shipmentBookingCode"
      :custCode="custCode"
      :shipmentStatus="shipmentStatus"
      @reload="$emit('reload')"
      @close="close()"
    />
  </el-dialog>
</template>
<script>
import BookingForm from './index.vue'
export default {
  components: { BookingForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
